import { render, staticRenderFns } from "./FriendsInvited.vue?vue&type=template&id=85ff3354&scoped=true"
import script from "./FriendsInvited.vue?vue&type=script&lang=js"
export * from "./FriendsInvited.vue?vue&type=script&lang=js"
import style0 from "./FriendsInvited.vue?vue&type=style&index=0&id=85ff3354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ff3354",
  null
  
)

export default component.exports